import React from 'react'
import { Link } from 'react-router-dom'
import { postdata } from '../contents/postdata'
import NoCover from '../images/NoCover.png'
import './Thumbnail.css'

export default function Thumbnail(props: any) {
  const authorid: string = props.authorid
  const id: string = props.id
  let data: { [key: string]: string } = postdata[authorid][id]
  if (data.cover == '') data.cover = NoCover
  return (
    <Link to={'/' + authorid + '/' + id} className="thumbnail-area">
      <img className="thumbnail-area-image" src={data.cover}></img>
      <h1>{data.title}</h1>
      <p className="thumbnail-view-tag">{data.tag}</p>
    </Link>
  )
}
